import Checkbox from "./Checkbox";
import AddNewCheckbox from "./AddNewCheckbox";
import style from "./ExpandableCheckboxList.module.css";
import { classnames } from "../../utils/index.jsx";
import useDependentField, {
  usePropertyExtractor,
} from "../../hooks/use-dependent-field";

export default function ExpandableCheckboxList({
  name,
  items,
  addItem,
  className,
  dependon,
}) {
  useDependentField(name, dependon, usePropertyExtractor(name));
  return (
    <div className={classnames(style.container, className)}>
      {items.map((checkboxItem) => (
        <Checkbox key={checkboxItem} name={name} value={checkboxItem} pillStyle>
          {checkboxItem}
        </Checkbox>
      ))}
      <AddNewCheckbox
        addItem={(item) => {
          addItem(name, item);
        }}
      />
    </div>
  );
}
